import { createSelector } from 'reselect'
import { State } from 'index'

const couponSelector = (state: State) => state.coupon

export const getConfirmCoupon = createSelector([couponSelector], (state) => state.confirm)
export const getCoupons = createSelector([couponSelector], (state) => state.coupons)
